import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { getCreatorInfo } from '../../store/actions';
import { useAppDispatch, useAppSelector } from '../../hooks';

import * as S from './style';

interface ArticleAuthorProps {
    fullname?: string;
    portrait?: string;
    username?: string;
    creator: string;
}

let i = 0;

const ArticleAuthor: React.FC<ArticleAuthorProps> = ({ creator }) => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { creators } = useAppSelector(state => state.creator);
    const user = creators.find(user => user.username === creator);
    const [IsCaseStudy, setIsCaseStudy] = useState(false);

    useEffect(() => {
        while (i <= creators.length) {
            if (user && user.username === creator) {
                return 
            } else {
                dispatch(getCreatorInfo(creator));
            }

            i++;
        }
    }, [dispatch, creator, creators.length, user && user.username])

    useEffect(() =>{
        const caseStudy = location.pathname.includes('/case-study');
        setIsCaseStudy(caseStudy);
    }, [location.pathname]);

    return (
        <S.AuthorInfo IsCaseStudy={IsCaseStudy}>
            <S.Image>
                <img src={user && user.portrait} alt={user && user.fullname}/>
            </S.Image>
            <S.Name>
                <span>Autore</span>
                <Link className="author-name" to={`/author/${creator}`}>{user && user.fullname || 'admin'}</Link>
            </S.Name>
        </S.AuthorInfo>
    )
}

export default ArticleAuthor;